import { StatusBadge, type StatusBadgeProps } from '@berky/ui'

import type { FeedbackStatus } from '../types'

const tones: Record<FeedbackStatus, StatusBadgeProps['tone']> = {
  Neu: 'info',
  'In Bearbeitung': 'warning',
  Zurückgestellt: 'neutral',
  Erledigt: 'success',
  Abgelehnt: 'error',
}

export function FeedbackStatusBadge({ status }: { status: FeedbackStatus }) {
  return <StatusBadge tone={tones[status]}>{status}</StatusBadge>
}
